<template>
  <div class="modal-news d-flex flex-column justify-content-start align-items-start">
    <div class="close-btn" @click="$root.hideNews()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M20 2.60225L18.2611 0.874268L10 9.0834L1.73892 0.874268L0 2.60225L8.26108 10.8114L0 19.0205L1.73892 20.7485L10 12.5394L18.2611 20.7485L20 19.0205L11.7389 10.8114L20 2.60225Z"
          fill="#000000"
        />
      </svg>
    </div>
    <p class="date mb-2">{{content.text}}</p>
    <p class="ttl mb-3">{{content.title}}</p>
    <wysiwyg-component v-html="content.wysiwyg"></wysiwyg-component>
    <button class="close-bottom" @click="$root.hideNews()">Закрыть</button>
  </div>
</template>

<script>
export default {
  props: {
    content: Object
  },
  data() {
    return {
      data: {}
    };
  }
};
</script>

<style lang="scss">
.modal-news {
  overflow-y: scroll;
  background: $defaultColor;
  border-radius: 8px;
  padding: 40px;
  width: 100%;
  max-width: 920px;
  max-height: 568px;
  position: relative;

  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .date {
    font-size: 14px;
    line-height: 150%;
    color: #7b7b7b;
  }
  .ttl {
    font-weight: 500;
    font-size: 24px;
    line-height: 110%;
    color: #000000;
  }
  .description {
    font-size: 16px;
    line-height: 160%;
    color: #000000;
    br {
      display: inline-block;
      width: 20px;
    }
  }
  .close-bottom {
    width: 180px;
    padding: 14px 0;
    background-color: $defaultColor;
    color: $activeColor;
    border: 1px solid $activeColor;
    border-radius: 6px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    margin-top: 40px;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: $activeColor;
      color: $defaultColor;
      border: 1px solid $activeColor;
    }
  }
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    padding: 20px;
    padding-top: 40px;
    .ttl {
      font-size: 24px;
    }
    .close-bottom {
      margin-top: 50px;
    }
  }
}
</style>